module.exports = __webpack_public_path__ + "static/dive-app-3359e8f4e22cd3e58a58fa3b52eb1853.png";